import angular from 'angular';
import template from './ecommerce-dashboard.html';
import EcommerceDashboardController from './ecommerce-dashboard.controller';
import EcommerceDashboardDirective from './EcommerceDashboard.module';

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state('drivecoach.admin.ecommercedashboard', {
        url: '/ecommerce-dashboard',
        controller: EcommerceDashboardController,
        controllerAs: 'vm',
        template: template,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner
            ]
        }
    });
}
config.$inject = ['$stateProvider', '$urlRouterProvider', 'USER_ROLES'];

export default angular
    .module('admin.ecommercedashboard', [EcommerceDashboardDirective.name])
    .config(config)
    .controller('EcommerceDashboardController', EcommerceDashboardController);
